/**
 * Default horizontal and vertical spacing for the entity map.
 */
export const DEFAULT_ENTITY_MAP_LAYOUT_SETTINGS = {
  horizontalSpaceBetweenNodes: 400,
  verticalSpaceBetweenNodes: 10,
};

/**
 * The limit of nodes that should be displayed in an entity map.
 *
 * We disable expanding the entity map from handles if the current total number of nodes exceeds this limit.
 * Note that this means that if we have a graph with ENTITY_MAP_TOTAL_NODE_LIMIT - 1 nodes, we're allowed to
 * further expand the entity map from handles, and get to a graph with as many as ENTITY_MAP_TOTAL_NODE_LIMIT
 * plus 30 nodes.
 */
export const ENTITY_MAP_TOTAL_NODE_LIMIT = 1000;
